/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { TestimonialItem } from '@coursera-web/cds-labs';

import { breakpoints } from '@coursera/cds-core';

import Section from 'bundles/front-page/components/Section';
import OverflowCarousel from 'bundles/front-page/components/overflow-carousel/OverflowCarousel';
import getTestimonialsData from 'bundles/front-page/utils/getTestimonials';

const styles = {
  testimonialsGrid: css`
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-template-rows: 1fr;
    gap: var(--cds-spacing-200);

    ${breakpoints.down('sm')} {
      /* 1024 / 4 = 256px */
      grid-template-columns: repeat(4, minmax(256px, 1fr));
    }
  `,
};

const getTestimonials = () => {
  // TODO: update with final copy and translate it.
  // https://coursera.atlassian.net/browse/MERCH-1786
  return {
    title: 'What our learners say',
    testimonials: getTestimonialsData(),
  };
};

const TestimonialsModuleRedesignRenderer = () => {
  const { title, testimonials } = getTestimonials();

  return (
    <Section title={title}>
      <OverflowCarousel css={styles.testimonialsGrid}>
        {testimonials.map((testimonial, index) => (
          <TestimonialItem
            key={testimonial.name}
            name={testimonial.name}
            quote={testimonial.quote}
            imageSrc={testimonial.imageSrc}
            learnerSince={testimonial.learnerSince}
            trackingIndex={index}
            forceUseDesktopStyles
          />
        ))}
      </OverflowCarousel>
    </Section>
  );
};

export default TestimonialsModuleRedesignRenderer;
